module.exports = __webpack_public_path__ + "static/media/stone1.106982ee.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/alset-reactgame-test/commonGameAssets/obstacles/stone1.png
// module id = 453
// module chunks = 0